import { render, staticRenderFns } from "./ModuleVideo.vue?vue&type=template&id=41a41127&scoped=true&"
import script from "./ModuleVideo.vue?vue&type=script&lang=js&"
export * from "./ModuleVideo.vue?vue&type=script&lang=js&"
import style0 from "./ModuleVideo.vue?vue&type=style&index=0&id=41a41127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a41127",
  null
  
)

export default component.exports